import { DatePicker, Form as FormAntd, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMerchantsStore } from 'store/merchants';

import { validateLessThanMonthDateRange } from './validators';

const Form = () => {
    const { t } = useTranslation();

    const currenciesOptions = useMerchantsStore('currencyFilter');

    return (
        <>
            <FormAntd.Item
                layout='vertical'
                name='currency'
                rules={[
                    {
                        required: true,
                        message: t('common.form_error.value_required'),
                    },
                ]}
            >
                <Select
                    showSearch
                    placeholder='Currency'
                    options={currenciesOptions}
                    optionFilterProp='label'
                />
            </FormAntd.Item>
            <FormAntd.Item
                layout='vertical'
                name='date'
                style={{ width: '100%' }}
                label={t('common.form.choosePeriod')}
                rules={[
                    {
                        required: true,
                        message: t('common.form_error.value_required'),
                    },
                    {
                        validator: validateLessThanMonthDateRange(t),
                    },
                ]}
            >
                <DatePicker.RangePicker
                    showTime
                    style={{ width: '100%' }}
                    placeholder={[
                        t('common.form.dateFrom'),
                        t('common.form.dateTo'),
                    ]}
                />
            </FormAntd.Item>
            <FormAntd.Item
                layout='vertical'
                label={t('common.form.enterEmail')}
                name='email'
                rules={[
                    {
                        required: true,
                        message: t('common.form_error.email_required'),
                    },
                    {
                        type: 'email',
                        message: t('common.form_error.email_wrong'),
                    },
                ]}
            >
                <Input placeholder='example@test.com' />
            </FormAntd.Item>
        </>
    );
};

export { Form };
